import React from 'react'
let PropTypes = React.PropTypes
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
import api from '../../apiClient/v1'
import { TablaProducciones } from './TablaProducciones.jsx'

export class MantenedorProducciones extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            clientes: this.props.clientes,
            // Por defecto seleccionar PUC
            idCliente: "1",
            // Por defecto jornada noche
            idJornada: "3",
            editandoValor: false,
            producciones: [],
            error: {}
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
        this.seleccionarCliente = (evt)=>{
            const idCliente = evt.target.value;
            this.setState({
                idCliente: idCliente
            }, ()=>{
                this.fetchProducciones()
            })
        }
        this.seleccionarJornada = (evt)=>{
            const idJornada = evt.target.value;
            this.setState({
                idJornada: idJornada
            }, ()=>{
                this.fetchProducciones()
            })
        }
        this.fetchProducciones = ()=>{
            api.produccion(this.state.idCliente, this.state.idJornada).getProducciones()
                .then(producciones=>{
                    this.setState({producciones})
                })
                .catch(this.ajaxErrorHandler('Error al buscar las producciones'))
        }
        this.editarValor = (idProduccion, valor)=>{
            let request = api.produccion(this.state.idCliente, this.state.idJornada).actualizarProduccion(idProduccion, valor);
            request
                .then(()=> this.fetchProducciones(),
                    this.refs.notificator.success("Cambio en producción", "Producción editada correctamente", 4*1000)
                )
                .catch(this.ajaxErrorHandler('Error al editar producción'));
            return request
        }
    }
    componentWillMount(){
        this.fetchProducciones()
    }
    render(){
        return(
            <div>
                <div className="row">
                    <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                    <div className="col-md-offset-4 col-md-6">
                        <h1>Producciones por región</h1>
                    </div>
                </div>
                <div className="row">
                    <SelectorCliente
                        idClienteSeleccionado={this.state.idCliente}
                        seleccionarCliente={this.seleccionarCliente}
                        clientes={this.state.clientes}
                    />
                    <SelectorJornada
                        idJornadaSeleccionada={this.state.idJornada}
                        seleccionarJornada={this.seleccionarJornada}
                    />
                </div>
                <div className="row">
                    <div className="col-md-9">
                        <label>Producciones del cliente</label>
                        <TablaProducciones
                            producciones={this.state.producciones}
                            editarValor={this.editarValor}
                        />
                    </div>
                </div>    

            </div>
        )
    }
}
const SelectorCliente = ({idClienteSeleccionado, seleccionarCliente, clientes})=>
        <div className="col-sm-2 form-group ">
            <label className="control-label" htmlFor="cliente">Seleccione cliente</label>
            <select className="form-control" name="cliente"
                    value={idClienteSeleccionado}
                    onChange={seleccionarCliente}
            >
                {clientes.map(cliente=>
                    <option key={cliente.idCliente} value={cliente.idCliente}>{`${cliente.nombreCorto}`}</option>
                )}
            </select>
        </div>
const SelectorJornada = ({idJornadaSeleccionada, seleccionarJornada})=>
        <div className="col-sm-2 form-group ">
            <label className="control-label" htmlFor="cliente">Seleccione jornada</label>
            <select className="form-control" name="cliente"
                    value={idJornadaSeleccionada}
                    onChange={seleccionarJornada}
            >
                    <option key="2" value="2">Día</option>
                    <option key="3" value="3">Noche</option>
            </select>
        </div>
MantenedorProducciones.propTypes = {
    clientes: PropTypes.array
}



// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorProducciones/producciones.jsx